import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import {withStyles} from '@material-ui/core/styles';
import Button from "@material-ui/core/Button"
import Chip from '@material-ui/core/Chip'
import cookie from 'react-cookies'

const styles = {
    limoInput: {
        borderRadius: "5rem",
        backgroundColor: "#ffffff",
        width: "80%",
        height: "6.9vh",
        minHeight: "45px",
        margin: "4%",
        border: "none",
        paddingLeft: "10%",
        fontFamily: "Saira",
        fontSize: "1rem",
        fontWeight: "normal",
        fontStyle: "normal",
        fontStretch: "normal",
        lineHeight: "normal",
        letterSpacing: "-0.3px",
        color: "#747474",
        outline: "0",
    },

    button: {
        "borderRadius": "5rem",
        "backgroundColor": "#004c45",
        "width": "90%",
        "margin": "3%",
        "height": "6.5vh",
        "fontFamily": "Saira",
        "fontSize": "1rem",
        "fontWeight": "600",
        "fontStyle": "normal",
        "fontStretch": "semi-condensed",
        "lineHeight": "normal",
        "letterSpacing": "normal",
        "textAlign": "center",
        "color": "#ffffff",

    },

    inputContainer: {},

    buttonContainer: {
        marginTop: '4vh'
    },

    errorWrapper: {
        display: "flex",
        justifyContent: "space-around",
        minHeight: '5vh'
    }

}

class ResetPassword extends Component {
    constructor(props) {
        super(props)

        this.state = {
            password: '',
            password_confirmation: '',
            errorMsg: '',
            showError: false,
            disabledButton: true,
            token: cookie.load('apiToken')
        }
    }

    handleChange = (event) => {
        let valueName = event.target.name
        let value = event.target.value

        this.setState({[valueName]: value}, () => {
            this.validatePassword()

        })
    }

    validatePassword = () => {
        const {password, password_confirmation} = this.state
        let passed = true;


        if (password.length < 5) {
            this.setState({errorMsg: "Legalább 6 karakter hosszúnak kell lennie!"})
            passed = false
        }

        if (password.length > 5 && password !== password_confirmation) {
            this.setState({errorMsg: "A két jelszónak meg kell egyeznie!"})
            passed = false
        }

        this.setState({showError: !passed, disabledButton: !passed})

    }

    submitPassword = () => {
        this.setState({disabledButton: true})
        const {password, password_confirmation, token} = this.state
        axios.post(
            '/api/user/save/password',
            {password: password, password_confirmation: password_confirmation},
            {headers: {Authorization: token}})
            .then((response) => {
                location.href = '/my-schedules'
            })
    }

    errorChip = () => {
        const {classes} = this.props
        const {errorMsg} = this.state
        return (
            <Chip
                label={errorMsg}
                className={classes.chip}
                color="secondary"
                hidden
            />
        )
    }

    render() {
        const {classes} = this.props
        let passwordInput =  React.createRef()
        let passwordConfirmInput = React.createRef()

        let focusToPasswordInput = () => {
            passwordInput.current.focus()
        }

        let focusToPasswordConfirmInput = () => {
            passwordConfirmInput.current.focus()
        }

        return (
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-8">
                        <div className="card">
                            <h1>Jelszó beállítása</h1>

                            <h3>
                                Ideiglenes jelszóval jelentkezett be, kérjük állítsa be új jelszavát!
                            </h3>

                            <div className={classes.errorWrapper}>
                                {this.state.showError ? this.errorChip() : null}
                            </div>
                            <div className={classes.inputContainer}>
                                <form>
                                    <input placeholder="Új jelszó"
                                           name={"password"}
                                           onChange={this.handleChange}
                                           value={this.state.password}
                                           className={classes.limoInput}
                                           min={6}
                                           ref={passwordInput}
                                           onClick={focusToPasswordInput}
                                           type="password"/>

                                    <input placeholder="Új jelszó újra"
                                           name={"password_confirmation"}
                                           className={classes.limoInput}
                                           value={this.state.password_confirmation}
                                           onChange={this.handleChange}
                                           ref={passwordConfirmInput}
                                           onClick={focusToPasswordConfirmInput}
                                           type="password"/>
                                </form>
                            </div>


                            <div className={classes.buttonContainer}>
                                <Button variant="contained" className={classes.button} onClick={this.submitPassword}
                                        disabled={this.state.disabledButton}>
                                    Mentés
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withStyles(styles)(ResetPassword)



// WEBPACK FOOTER //
// ./resources/js/components/ResetPassword.js